import React, { useEffect, useRef, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications, PRODUCT_IMAGE } from '../data/content';
type Notice = {
  name: string;
  country: string;
  minutes: number;
};
function randomNotice(): Notice {
  const person = purchaseNotifications[Math.floor(Math.random() * purchaseNotifications.length)];
  return {
    ...person,
    minutes: 1 + Math.floor(Math.random() * 12)
  };
}
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const [dismissed, setDismissed] = useState(false);
  const timers = useRef<number[]>([]);
  useEffect(() => {
    if (dismissed) return;
    let cancelled = false;
    const cycle = (delay: number) => {
      const showId = window.setTimeout(() => {
        if (cancelled) return;
        setNotice(randomNotice());
        const hideId = window.setTimeout(() => {
          if (cancelled) return;
          setNotice(null);
          cycle(9000 + Math.random() * 8000);
        }, 6000);
        timers.current.push(hideId);
      }, delay);
      timers.current.push(showId);
    };
    cycle(7000);
    return () => {
      cancelled = true;
      timers.current.forEach(id => window.clearTimeout(id));
      timers.current = [];
    };
  }, [dismissed]);
  return <AnimatePresence data-id="element-38" data-mp="1axhdkropt857">
      {notice && !dismissed && <motion.div initial={{
      opacity: 0,
      y: -16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: -12,
      scale: 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed left-3 right-3 top-3 z-50 mx-auto max-w-sm rounded-xl border border-white/10 bg-ink-800/95 p-3 shadow-2xl backdrop-blur sm:left-4 sm:right-auto sm:top-4 sm:mx-0" role="status" data-id="element-39" data-mp="n6bqbrgg3dkv">
          <div className="flex items-center gap-3" data-id="element-40" data-mp="23ld6rmf2shx8">
            <img src={PRODUCT_IMAGE} alt="" className="h-11 w-11 shrink-0 rounded-lg bg-ink-950 object-contain p-0.5" data-id="element-41" data-mp="23kv3w6xwr5gc" />
            <div className="min-w-0 flex-1" data-id="element-42" data-mp="2fmv24urttos1">
              <p className="truncate text-sm font-bold text-white" data-id="element-43" data-mp="2fpqzagvuo9ff">
                {notice.name} · {notice.country}
              </p>
              <p className="text-xs text-white/60" data-id="element-44" data-mp="2pmdkj6s392hz">
                vient d’acheter le Système Maître de Soudage™
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wide text-arc-400" data-id="element-45" data-mp="1rzeishmjh4d8">
                <CheckCircle2Icon className="h-3 w-3" aria-hidden="true" data-id="element-46" data-mp="1wxg5rdn35ntz" />
                Achat vérifié · il y a {notice.minutes} min
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Fermer la notification" className="shrink-0 rounded-md p-1 text-white/40 transition-colors duration-150 ease-out hover:text-white" data-id="element-47" data-mp="26o16p7q8f4g2">
              <XIcon className="h-4 w-4" data-id="element-48" data-mp="3rh86vbb94tnf" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}